import { render, staticRenderFns } from "./microShopGoodsCate.vue?vue&type=template&id=482e9de8&scoped=true&"
import script from "./microShopGoodsCate.vue?vue&type=script&lang=js&"
export * from "./microShopGoodsCate.vue?vue&type=script&lang=js&"
import style0 from "./microShopGoodsCate.vue?vue&type=style&index=0&id=482e9de8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482e9de8",
  null
  
)

component.options.__file = "microShopGoodsCate.vue"
export default component.exports